import { Table } from '../../../../../../common/table'
import { TBodyCustom } from './TBodyCustom'

const TableSectorPerformance = ({ dataTable, isDynamicReport }) => {
  const {
    typeComponent,
    data,
    headers,
    selectDataTable,
    selectCellData,
    selectRowGroup,
    isLoading,
    compareVal,
  } = dataTable

  return (
    <Table
      ids={data?.ids}
      isNoDataWithHead={false}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
      getDataFromRedux={selectDataTable(typeComponent)}
      schema={headers}
      isLoading={isLoading}
      renderTBody={() => {
        return (
          <TBodyCustom
            typeComponent={typeComponent}
            ids={data?.ids}
            selectCellData={selectCellData}
            selectRowGroup={selectRowGroup}
            schema={headers}
            isDynamicReport={isDynamicReport}
            compareVal={compareVal}
          />
        )
      }}
    />
  )
}

export default TableSectorPerformance
